import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 询比采购路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @param listRoute
 * @param needIcon
 * @returns <Object> route
 */
export default function generateInquiryRoutes(
  modulePath = 'inquiry',
  prefix = '',
  sideMenuTitle = '询比采购',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right],
  listRoute = {},
  needIcon = true
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: needIcon ? 'icon-side_purchase_inquiry' : '',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 项目列表
      Object.assign(
        {},
        {
          path: 'list',
          name: `${prefix}InquiryList`,
          component: '/procure-views/inquiry/inquiry-list/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '项目列表',
            cache: true,
            hidden: true,
            pageComponentName: 'InquiryList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities,
          roles: [
            ...roles,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        listRoute
      ),

      // 新增询比单
      {
        path: 'orders/:orderId?/projects/:projectId?/edit/:isCopy?',
        name: `${prefix}InquiryForm`,
        component: '/procure-views/inquiry/inquiry-form/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '新增询比单',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 发布预览
      {
        path: 'orders/:orderId?/projects/:projectId?/preview',
        name: `${prefix}InquiryFormPreview`,
        component: '/procure-views/inquiry/inquiry-form/preview',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '发布预览',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 询比单详情
      {
        path: 'orders/:orderId/detail',
        name: `${prefix}InquiryDetail`,
        component: '/procure-views/inquiry/inquiry-detail/order-info/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '询比单详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 接受报价
      {
        path: 'orders/:orderId/accepted',
        name: `${prefix}InquiryOfferAccepted`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/accepted-info/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '接受报价',
          cache: true,
          hidden: true,
          pageComponentName: 'InquiryOfferAccepted'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名审核
      {
        path: 'orders/:orderId/accepted/check/trades/:tradeId/approvals',
        name: `${prefix}InquiryApprovalCheck`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/approval-check/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名审核',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 邀请详情
      {
        path:
          'orders/:orderId/accepted/invite-detail/trades/:tradeId/invites/:inviteId',
        name: `${prefix}InquiryInviteDetail`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/invite-detail/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '邀请详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报价详情
      {
        path:
          'orders/:orderId/order-name/accepted/trade-detail/rounds/:roundId/trades/:tradeId/offers/:offerId',
        name: `${prefix}InquiryQuoteDetail`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/quote-detail/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报价详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 全选比价
      {
        path: 'orders/:orderId/accepted/compare-all/rounds/:roundId',
        name: `${prefix}InquiryCompareAll`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/compare-all/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '全选比价',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 多轮报价
      {
        path:
          'orders/:orderId/accepted/compare-all/rounds/:roundId/multiple-rounds',
        name: `${prefix}InquiryMultipleRounds`,
        component:
          '/procure-views/inquiry/inquiry-detail/offer-accepted/multiple-rounds/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '多轮报价',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 线上评审
      {
        path: ':orderId/online-review',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '线上评审',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: [],

        children: [
          // 线上评审文件
          {
            path: 'file',
            name: `${prefix}InquiryOnlineReviewFile`,
            component: '/procure-views/online-review/review-file',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审文件',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审设置
          {
            path: 'setting',
            name: `${prefix}InquiryOnlineReviewSetting`,
            component: '/procure-views/online-review/review-setting',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审设置',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审大厅
          {
            path: ':reviewId/hall',
            name: `${prefix}InquiryOnlineReviewHall`,
            component: '/procure-views/online-review/review-hall',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审大厅',
              layout: 'NoLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审报告
          {
            path: ':reviewId/report',
            name: `${prefix}InquiryOnlineReviewReport`,
            component: '/procure-views/online-review/review-report',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审报告',
              layout: 'NoLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 确定候选
      {
        path: 'orders/:orderId/candidate/edit/:edit?',
        name: `${prefix}InquiryOrderCandidate`,
        component:
          '/procure-views/inquiry/inquiry-detail/order-candidate/order-candidate',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '确定候选',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 候选审批详情
      {
        path: 'orders/:orderId/candidate/audit',
        name: `${prefix}InquiryOrderCandidateNewest`,
        component:
          '/procure-views/inquiry/inquiry-detail/order-candidate/order-candidate-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '候选审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 确定成交
      {
        path: 'orders/:orderId/winner/edit/:edit?',
        name: `${prefix}InquiryOrderWinner`,
        component:
          '/procure-views/inquiry/inquiry-detail/winner-confirm/order-winner',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '确定成交',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 成交审批详情
      {
        path: 'orders/:orderId/winner/audit',
        name: `${prefix}InquiryOrderWinnerNewest`,
        component:
          '/procure-views/inquiry/inquiry-detail/winner-confirm/order-winner-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '成交审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 信息变更
      {
        path: 'orders/:orderId/changes/content/:edit?',
        name: `${prefix}InquiryContentChanges`,
        component:
          '/procure-views/inquiry/inquiry-detail/changes/content-changes',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '信息变更',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更审批详情
      {
        path: 'orders/:orderId/changes/content/audit/info',
        name: `${prefix}InquiryChangeNewestDetail`,
        component:
          '/procure-views/inquiry/inquiry-detail/changes/change-newest-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更公告
      {
        path: 'orders/:orderId/changes/detail',
        name: `${prefix}InquiryChangeDetail`,
        component:
          '/procure-views/inquiry/inquiry-detail/changes/change-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更公告',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 答疑澄清
      {
        path: 'orders/:orderId/clarification',
        name: `${prefix}InquiryClarificationFile`,
        component:
          '/procure-views/inquiry/inquiry-detail/changes/clarification-file',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '答疑澄清',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 追加供应商
      {
        path: 'orders/:orderId/abnormal/add-supplier',
        name: `${prefix}InquiryAddSupplier`,
        component: '/procure-views/inquiry/abnormal/add-supplier',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '追加供应商',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标处理
      {
        path: 'orders/:orderId/abnormal/abortive-bidding',
        name: `${prefix}InquiryAbortiveBidding`,
        component: '/procure-views/inquiry/abnormal/abortive-bidding',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标处理',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标审批详情
      {
        path: 'orders/:orderId/abnormal/abortive-bidding-newest',
        name: `${prefix}InquiryAbortiveBiddingNewest`,
        component: '/procure-views/inquiry/abnormal/abortive-bidding-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 重新确定候选
      {
        path: 'orders/:orderId/abnormal/re-candidate/edit/:edit?',
        name: `${prefix}InquiryReCandidate`,
        component:
          '/procure-views/inquiry/inquiry-detail/order-candidate/order-candidate',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '重新确定候选',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 重新候选审批详情
      {
        path: 'orders/:orderId/abnormal/re-candidate/audit',
        name: `${prefix}InquiryOrderReCandidateNewest`,
        component:
          '/procure-views/inquiry/inquiry-detail/order-candidate/order-candidate-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '重新候选审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 重新确定成交
      {
        path: 'orders/:orderId/abnormal/re-winner/edit/:edit?',
        name: `${prefix}InquiryReWinner`,
        component:
          '/procure-views/inquiry/inquiry-detail/winner-confirm/order-winner',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '重新确定成交',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 重新成交审批详情
      {
        path: 'orders/:orderId/abnormal/re-winner/audit',
        name: `${prefix}InquiryOrderReWinnerNewest`,
        component:
          '/procure-views/inquiry/inquiry-detail/winner-confirm/order-winner-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '重新成交审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 保证金退款
      {
        path: 'orders/:orderId/guarantee/refund/list',
        name: `${prefix}InquiryGuaranteeRefund`,
        component: '/procure-views/inquiry/guarantee/refund',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '保证金退款',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      }
    ]
  }
}
